import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-seller-activation-card',
  templateUrl: './seller-activation-card.component.html',
  styleUrls: ['./seller-activation-card.component.scss'],
})
export class SellerActivationCardComponent {
  
  // Propiedades de entrada con valores predeterminados (0)
  // Utilizamos 'number | null' en el @Input para reflejar que el valor inicial podría ser null/undefined antes de la carga.
  @Input() totalClientsAssigned: number | null = 0;
  @Input() totalClientsActivated: number | null = 0;
  @Input() activationRatePercentage: number | null = 0;

  constructor() {}

  /**
   * Determina la clase de color basada en la tasa de activación.
   * La corrección previene el error 'toFixed' en null.
   */
  getRateColor(): string {
    // Si el valor es null o undefined, usa 0
    const rate = this.activationRatePercentage || 0; 

    if (rate >= 75) {
      return 'high-rate';
    } else if (rate >= 50) {
      return 'medium-rate';
    } else {
      return 'low-rate';
    }
  }

  /**
   * Formatea la tasa de activación a dos decimales.
   * CORRECCIÓN PRINCIPAL: Asegura que el valor no sea nulo antes de llamar a toFixed(2).
   */
  get formattedRate(): string {
    // Si el valor es null o undefined, usa 0
    const rate = this.activationRatePercentage || 0;
    
    // Ahora es seguro llamar a toFixed(2)
    return rate.toFixed(2);
  }
}